export default __webpack_public_path__ + "static/media/4-Cloudxier-PTBIS.168a42fb.png";